const WORDS = [
  "Pan Dulce", "Arepas", "Wood-Fired Pizza", "Pepián", "Empanadas",
  "Bandeja Paisa", "Tamales", "Pasteles", "Chuchitos", "Café",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section className="bg-ink py-6 md:py-8 overflow-hidden border-y border-ink" data-testid="marquee">
      <div className="marquee">
        {row.map((w, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif italic text-dough text-3xl md:text-5xl px-6 md:px-10">{w}</span>
            <span className="text-maize text-2xl md:text-3xl">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
};
